import { httpRequest } from "@services/http";

export interface UpdateJourneyStepPayload {
  name?: string;
  parent_id?: number | null;
  sequence?: number;
}

export class CommandUpdateJourneyStep {
  async run(journeyId: number, stepId: number, payload: UpdateJourneyStepPayload) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/journeys/${journeyId}/steps/${stepId}/`;
    return await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }
}
